import React, { useEffect, useRef, useState } from "react";
import styles from "./Products.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { List } from "antd";
import productImg1 from "../../../../assets/images/staticImages/md1.png";
import productImg2 from "../../../../assets/images/staticImages/md2.png";
import productImg3 from "../../../../assets/images/staticImages/md3.png";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { AiFillProduct } from "react-icons/ai";
import { MdOutlineTravelExplore } from "react-icons/md";
import { useNavigate } from "react-router-dom";
const Products = () => {
  const scrollRef = useRef(0);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  const handleScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth, hidden } = scrollRef.current;
    setIsAtStart(scrollLeft === 0);
    setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
  };

  const scrollLeft = () => {
    scrollRef.current.scrollLeft -= width < 500 ? 200 : 400;
    handleScroll(); // Update button visibility immediately
  };

  const scrollRight = () => {
    scrollRef.current.scrollLeft += width < 500 ? 200 : 400;
    handleScroll(); // Update button visibility immediately
  };

  useEffect(() => {
    handleScroll(); // Set initial state
  }, []);

  const dummyProducts = [
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16",
      items: "100",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
      items: "100",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
      items: "100",
    },
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16 Phoenix Immobilizer N16",
      items: "100",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
      items: "100",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
      items: "100",
    },
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
    },
    {
      id: 1,
      image: productImg1,
      name: "Phoenix Immobilizer N16 Phoenix Immobilizer N16",
    },
    {
      id: 2,
      image: productImg2,
      name: "Dragon Shield S20",
    },
    {
      id: 1,
      image: productImg3,
      name: "Griffin Gauntlet G12",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <div className={styles.productsCont}>
        <div className={styles.products_header}>
          <TextComponent
            text={"Phoenix top Products"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--heading2-font-size)",
            }}
          />
          {width < 500 ? (
            <div className={styles.products_exploreBtn}>
              <MdOutlineTravelExplore size={20} color={"var(--white-color)"} />
            </div>
          ) : (
            <SubmitButton
              title={"Explore now"}
              btnClass={styles.products_headerBtn}
            />
          )}
        </div>
        <div className={styles.scrollContainerWrapper}>
          {!isAtStart && (
            <div onClick={scrollLeft} className={styles.arrowBtnLeft}>
              <IoIosArrowBack />
            </div>
          )}
          <div
            className={styles.products_list}
            ref={scrollRef}
            onScroll={handleScroll}
          >
            {dummyProducts?.map((item, index) => (
              <div className={styles.products_listItem} onClick={()=>navigate("/order", {state: {item}})}>
                <img className={styles.products_listImg} src={item?.image} />
                <TextComponent
                  text={item?.name}
                  className={styles.products_listText}
                />
                <div className={styles.products_listBtnDiv}>
                  <SubmitButton
                    title={"Order now"}
                    textStyle={{ fontFamily: "Urbanist-regular" }}
                    btnClass={styles.products_listBtn}
                  />
                </div>
              </div>
            ))}
          </div>
          {!isAtEnd && (
            <div onClick={scrollRight} className={styles.arrowBtnRight}>
              <IoIosArrowForward />
            </div>
          )}
        </div>
      </div>
      <div className={styles.order_mainCont}>
        <div className={styles.orders_cont}>
          <TextComponent
            text={"Past order"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <List
            dataSource={dummyProducts}
            className={styles.orders_list}
            renderItem={(item, index) => (
              <div className={styles.orders_listItem} key={index}>
                <div className={styles.orders_listImg}>
                  <img src={item?.image} />
                  <div className={styles.orders_textdiv}>
                    <TextComponent
                      text={item?.name}
                      style={{ fontFamily: "Urbanist-bold" }}
                    />
                    <TextComponent
                      text={`${item?.items ? item?.items : "0"} items`}
                    />
                  </div>
                </div>
                <SubmitButton
                  title={"Re orders"}
                  onClick={()=>navigate("/order",{state: {item, status: "reOrder"}})}
                  btnClass={styles.orders_btnDiv}
                  textStyle={{ fontFamily: "Urbanist-regular" }}
                />
              </div>
            )}
          />
        </div>
        <div className={styles.orders_cont}>
          <TextComponent
            text={"Pending orders"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--dashboard_tabs-font-size)",
            }}
          />
          <List
            dataSource={dummyProducts}
            className={styles.orders_list}
            renderItem={(item, index) => (
              <div className={styles.orders_listItem} key={index} onClick={()=>navigate("/order",{state: {item, status: "pendingOrder"}})}>
                <div className={styles.orders_listImg}>
                  <img src={item?.image} />
                  <div className={styles.orders_textdiv}>
                    <TextComponent
                      text={item?.name}
                      style={{ fontFamily: "Urbanist-bold" }}
                    />
                    <TextComponent
                      text={`${item?.items ? item?.items : "0"} items`}
                    />
                  </div>
                </div>
                {/* <SubmitButton title={"Re orders"} btnClass={styles.orders_btnDiv} textStyle={{fontFamily: "Urbanist-regular"}}/> */}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default Products;
